import React, { useEffect, useState } from "react";
import {
  FaRegCheckCircle,
  FaCheck,
  FaLock,
  FaChevronDown,
  FaChevronUp,
  FaUserCircle,
  FaBars,
} from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { getEmail } from "../../../DecodeToken/DecodeToken.jsx";
import { getMentorProfileCompletionStatus } from "../../../ApiServices/ApiServices.jsx";
import { handleError } from "../../../Utils.js";
import Profile from "../Profile/Profile.jsx";
import TimeSlots from "../TimeSlots/TimeSlots.jsx";
import VerificationModal from "./VerificationModal.jsx";

const MentorProfileStatusProgress = ({ setHasProfileApproved }) => {
  const [isSubsectionOpen, setIsSubsectionOpen] = useState(true);
  const [isProfileCompleted, setIsProfileCompleted] = useState(false);
  const [isPriceDefined, setIsPriceDefined] = useState(false);
  const [isAvailabilityDefined, seIsAvailabilityDefined] = useState(false);
  const [requestedForApproval, setRequestedForApproval] = useState(false);
  const email = getEmail();

  const [isVisibleProfile, setIsVisibleProfile] = useState(false);
  const [isVisibleTimeSlots, setIsVisibleTimeSlots] = useState(false);
  const [isVisibleVerificationModel, setIsVisibleVerificationModel] =
    useState(false);

  const fetchProgressStatus = async () => {
    try {
      const status = await getMentorProfileCompletionStatus(email);
      setIsProfileCompleted(status?.status?.isProfileCompleted);
      setIsPriceDefined(status?.status?.isPriceDefined);
      seIsAvailabilityDefined(status?.status?.isAvailabilityDefined);
      setRequestedForApproval(status?.requestedForApproval);
      setHasProfileApproved(status?.getVerified);
    } catch (error) {
      return handleError(error?.response?.data?.message);
    }
  };
  useEffect(() => {
    if (email) {
      fetchProgressStatus();
    }
  }, [email]);

  const toggleSubsection = () => {
    // setIsSubsectionOpen(!isSubsectionOpen);
  };

  return (
    <div>
      <section className="relative w-full max-w-[800px] mx-auto h-[500px] overflow-y-auto p-2 mt-6 border border-gray-300 custom-scrollbar rounded-xl">
        <div className="px-2">
          <h1 className="text-xl font-semibold">
            Setting Up Your Mentor Profile
          </h1>
          <p className="text-gray-500 text-sm pb-1 text-[17px]">
            Kickstart mentoring with a mentor profile
          </p>
          {/* <p className="text-red-700 font-bold text-[15px]">33% Completed</p> */}

          <div className="flex items-center mt-1">
            <div className="w-full h-1 bg-gray-200 relative">
              {/* <div className="h-full bg-red-500 w-1/3"></div> */}
            </div>
            {/* <span className="ml-2 text-black">1/3</span> */}
          </div>

          <div className="mt-1"></div>
          <p className="text-gray-500 text-sm">Next Steps</p>

          <div className="mt-5"></div>
          <div className="space-y-3">
            <div className="flex items-center">
              <FaUserCircle className="text-3xl mr-5" />
              <span className="ml-1 font-bold text-[18px]">
                Create Your Mentor Profile
              </span>
              <FaCheck className="ml-auto text-green-500 text-3xl border-2 border-green-500 rounded-full p-1 bg-green-100 bg-opacity-50" />
            </div>
            <p className="mt-0 text-gray-500 ml-[54px]">
              You have successfully created your account
            </p>
          </div>
          <hr className="my-3 border-gray-300 border-2" />

          <div className="space-y-3">
            <div className="flex items-center">
              <FaBars className="text-2xl mr-5" />
              <span className="ml-2 font-bold text-[18px]">
                Setting Up Your Profile
              </span>
            </div>
            <div className="flex items-center ml-[54px]">
              <p className="text-gray-500 mt-0">
                Let's get started with these essential steps...
              </p>

              {/* Conditional rendering of the downward/upward icon */}
              {/* {isSubsectionOpen ? (
                <FaChevronUp
                  className="ml-auto cursor-pointer text-xl"
                  onClick={toggleSubsection}
                />
              ) : (
                <FaChevronDown
                  className="ml-auto cursor-pointer text-xl"
                  onClick={toggleSubsection}
                />
              )} */}
            </div>

            {/* Subsections */}
            {isSubsectionOpen && (
              <div className="ml-5 mt-2 space-y-2">
                <div className="flex items-center cursor-pointer" onClick={() => setIsVisibleProfile(!isVisibleProfile)}>
                  <span
                    className="text-gray-500 ml-[37px] hover:text-blue-600"
                  >
                    Set up your Mentor Profile
                  </span>
                  {isProfileCompleted ? (
                    <FaCheck className="ml-auto text-green-500 text-xl border-2 border-green-500 rounded-full p-1 bg-green-100 bg-opacity-50" />
                  ) : (
                    <FaLock className="ml-auto text-gray-500" />
                  )}
                </div>

                <hr className="my-2 border-gray-700 border-2 ml-8" />
                <NavLink className="flex items-center" to={"/dashboard/sessions"}>
                  <span className="text-gray-500 ml-[37px]">
                    <span
                      className="text-gray-500"
                    >
                      Set up your mentor pricing
                    </span>
                  </span>
                  {isPriceDefined ? (
                    <FaCheck className="ml-auto text-green-500 text-xl border-2 border-green-500 rounded-full p-1 bg-green-100 bg-opacity-50" />
                  ) : (
                    <FaLock className="ml-auto text-gray-500" />
                  )}
                </NavLink>
                <hr className="my-2 border-gray-700 border-2 ml-8" />
                <div className="flex items-center cursor-pointer" onClick={() => setIsVisibleTimeSlots(!isVisibleTimeSlots)}>
                  <span className="text-gray-500 ml-[37px] hover:text-blue-600">
                    <span
                    >
                      Set up your Availability
                    </span>
                  </span>
                  {isAvailabilityDefined ? (
                    <FaCheck className="ml-auto text-green-500 text-xl border-2 border-green-500 rounded-full p-1 bg-green-100 bg-opacity-50" />
                  ) : (
                    <FaLock className="ml-auto text-gray-500" />
                  )}
                </div>
              </div>
            )}
          </div>

          <hr className="my-3 border-gray-300 border-2" />

          <div className="space-y-3">
            <div className="flex items-center cursor-pointer" onClick={() =>
                  setIsVisibleVerificationModel(!isVisibleVerificationModel)
                }>
              <FaRegCheckCircle className="text-gray-500 text-2xl mr-5" />
              <span
                className="ml-2 font-bold text-[18px] hover:underline"
              >
                Get Verified and Listed
              </span>
              {requestedForApproval ? (
                <p className="ml-auto text-yellow-600">Approval Pending</p>
              ) : (
                <FaLock className=" ml-auto text-gray-500 text-2xl" />
              )}
            </div>
            <p className="text-gray-500 ml-[54px] mt-0">
              Please complete the above steps before booking your verification.
            </p>
          </div>
        </div>
      </section>
      <Profile
        isVisible={isVisibleProfile}
        setIsVisible={setIsVisibleProfile}
        fetchProgressStatus={fetchProgressStatus}
      />
      <TimeSlots
        isVisible={isVisibleTimeSlots}
        setIsVisible={setIsVisibleTimeSlots}
        fetchProgressStatus={fetchProgressStatus}
      />
      {isVisibleVerificationModel && (
        <VerificationModal
          onClose={setIsVisibleVerificationModel}
          fetchProgressStatus={fetchProgressStatus}
        />
      )}
    </div>
  );
};

export default MentorProfileStatusProgress;
